import React, { ReactNode } from 'react';
import { FieldRenderProps } from 'react-final-form';

type Props = FieldRenderProps<string> & {
  placeholder: React.ReactNode;
  fieldType?: string;
  required?: boolean;
};

type State = {
};

class CheckboxInput extends React.Component<Props, State> {
  static defaultProps = {
    fieldType: 'checkbox',
    required: false,
  };

  state: State = {
  };

  render(): ReactNode {
    const htmlFor = this.props.input.name;
    return (
      <div className="checkbox-input-group">
        <input
          type={this.props.fieldType}
          className="checkbox-input-field"
          value={this.props.input.value}
          onChange={this.props.input.onChange}
          id={htmlFor}
          required={this.props.required}
        />
        <label htmlFor={htmlFor} className="checkbox-input-placeholder">{this.props.placeholder}</label>
      </div>
    );
  }
}

export default CheckboxInput;
